import { render, staticRenderFns } from "./PharmacyDetails.vue?vue&type=template&id=a0bf0ed4&"
import script from "./PharmacyDetails.vue?vue&type=script&lang=js&"
export * from "./PharmacyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports